<div
	id="btn_lead_export"
	class="form-group tig-form-button"
	[formGroup]="OBJ_form_group"
	[ngClass]="{'has-error': isInvalid()}">
	<label class="col-lg-2 control-label" [ngClass]="{'tgi-required': isRequired()}">
		<span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
	<div class="col-lg-8">
		<button type="button" #btn class="tig-button tig-button-formbuilder b-r-xs btn btn-primary" (click)="openIFrame(btn)" [disabled]="OBJ_field_config?.readonly">{{getLabelName()|translate}}</button>
		<span class="tig-hint">{{OBJ_field_config?.hint|translate}}</span>
		<tig-form-error [OBJ_form_control]="OBJ_form_group.get(OBJ_field_config.name)"></tig-form-error>
	</div>
</div>

<ng-template #OBJ_model_iframe>
	<div class="modal-header tig-modal-header-formbuilder">
		<button type="button" class="btn btn-secondary" (click)="closeIFrame()">{{"oDetail.sCancel" | translate}}</button>
	</div>
	<div class="modal-body tig-modal-body-formbuilder">
		<div class="tig-iframe-formbuilder tig-iframe">
			<!-- default is desktop width -->
			<iframe id="{{getIFrameID()}}" width="100%" height="80%" frameborder="0" allowfullscreen [srcdoc]="OBJ_iframe_content"></iframe>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>
